<template>
  <div id="bar-chart-2" />
</template>

<script>
// import { getAllLocalGrossValue2 } from '../../api/colunm1'
import axios from 'axios'
export default {
  data () {
    return {
      xData: [],
      yData: [],
      chart: null,
      timer: null,
      normal: {
        show: true,
        lineHeight: 30,
        width: 80,
        height: 30,
        borderRadius: 200,
        position: "outside",
        distance: 1,
        color: "#fff",
      }
    }
  },

  mounted () {
    this.getBarChartData()
  },

  methods: {
    // getBarChartData () {
    //   let tempXData = []
    //   let tempyData = []
    //   getAllLocalGrossValue2().then(res => {
    //     res.forEach(element => {
    //       tempXData.push(element.name)
    //       tempyData.push(element.value)
    //     })
    //     if (this.yData.length !== tempyData.length) {
    //       this.xData = tempXData
    //       this.yData = tempyData
    //       this.barChartInit()
    //       this.timer && clearInterval(this.timer)
    //       this.timer = setTimeout(this.getBarChartData, 1000 * 10)
    //     } else {
    //       const changeNumberIndex = []
    //       this.timer && clearInterval(this.timer)
    //       this.yData.forEach((element, index) => {
    //         if (element !== tempyData[index]) changeNumberIndex.push(index)
    //       })
    //       if (changeNumberIndex.length === 0) {
    //         this.timer = setTimeout(this.getBarChartData, 1000 * 10)
    //       } else {
    //         changeNumberIndex.forEach(element => {
    //           this.yData[element] = 0
    //         })
    //         this.normal.show = false
    //         this.barChartInit()
    //         setTimeout(() => {
    //           this.normal.show = true
    //           this.yData = tempyData
    //           this.barChartInit()
    //           this.timer && clearInterval(this.timer)
    //           this.timer = setTimeout(this.getBarChartData, 1000 * 10)
    //         }, 1000)
    //       }
    //     }
    //   })
    // },

    getBarChartData () {
      let tempXData = []
      let tempyData = []
      axios.get('https://sry.chuangxing.ren/api/index/getAllIndustryYear?server=1')
        .then(response => {
          if (response.data && response.data.code === 1) {
            const res = response.data.data
            res.forEach(element => {
              tempXData.push(element.name)
              tempyData.push((element.value/10000).toFixed(2))
            })
            let changeIndex = Math.floor(Math.random() * (tempyData.length - 1))
            let changeValue = tempyData[changeIndex]
            tempyData[changeIndex] = 0
            this.normal.show = false
            this.xData = tempXData
            this.yData = tempyData
            this.barChartInit()
            setTimeout(() => {
              this.normal.show = true
              tempyData[changeIndex] = changeValue
              this.xData = tempXData
              this.yData = tempyData
              this.barChartInit()
              this.timer && clearInterval(this.timer)
              this.timer = setTimeout(this.getBarChartData, 1000 * 15)
            }, 1000 * 1)
          } else {
            console.error('获取数据失败:', response.data)
          }
        })
        .catch(error => {
          console.error('API请求错误:', error)
          this.timer && clearInterval(this.timer)
          this.timer = setTimeout(this.getBarChartData, 1000 * 15)
        })
    },

    barChartInit () {
      const option = {
        backgroundColor: {
          type: "linear",
          x2: 0.5,
          y2: 1,
          colorStops: [
            {
              offset: 0,
              color: "rgba(14, 49, 155, 0.5)"
            },
            {
              offset: 0.6,
              color: "rgba(7, 20, 73, 0.5)"
            },
            {
              offset: 1,
              color: "rgba(14, 49, 155, 0.5)"
            },
          ],
          global: false // 缺省为 false
        },
        title: {
          text: '当年行业物流总产值（单位：亿元）',
          x: "center",
          y: "4%",
          textStyle: {
            color: "#fff",
            fontSize: "22",
          },
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          top: "15%",
          right: "5%",
          left: "5%",
          bottom: "15%",
        },
        xAxis: [{
          type: "category",
          data: this.xData,
          axisLine: {
            lineStyle: {
              width: 3,
              color: "#fff",
              cap: "round",
              join: "miter",
            },
          },
          axisTick: {
            // 不显示刻度
            show: false
          },
          axisLabel: {
            interval: 0,
            textStyle: {
              fontSize: 14
            }
          }
        }],
        yAxis: [
          {
            show: false,
            max: (value) => {
              return value.max + 50
            }
          }
        ],
        series: [{
          type: "bar",
          data: this.yData,
          barWidth: "40px",
          itemStyle: {
            normal: {
              color: new this.$echarts.graphic.LinearGradient(
                0, 0, 0, 1,
                [
                  {
                    offset: 0,
                    color: "rgba(0,244,255,1)", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(0,77,167,0)", // 100% 处的颜色
                  },
                ],
                false
              ),
              barBorderRadius: [30, 30, 0, 0],
              shadowColor: "rgba(0,160,221,1)",
              shadowBlur: 4,
            }
          },
          label: {
            normal: this.normal
          }
        }]
      }
      if (this.chart) {
        this.chart.setOption(option)
      } else {
        this.chart = this.$echarts.init(document.getElementById("bar-chart-2"))
        this.chart.setOption(option)
      }
    }
  }
}
</script>

<style>
#bar-chart-2 {
  width: 648px;
  height: 367px;
}
</style>